import { themeAtom } from "../../../shared/atoms";
import type { AdminOnboardingTopBarProps } from "../../models/admin-onboarding.models";
import { ArrowPathIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

const AdminOnboardingTopBar = ({
  search,
  rowCount,
  totalCount,
  disabled,
  onSearch,
  onRefresh,
}: AdminOnboardingTopBarProps) => {
  const theme = useAtomValue(themeAtom);

  return (
    <header
      data-test="admin-onboarding-top-bar"
      className="flex flex-none flex-wrap items-center gap-3 border-b border-gray-200 bg-white px-3 py-2 dark:border-gray-700 dark:bg-gray-800"
    >
      <h1 className={twMerge("text-sm font-semibold", theme.home.tailwind.textDefault)}>Onboarding</h1>
      <span data-test="admin-onboarding-count" className="text-xs opacity-70">
        {rowCount} of {totalCount} records
      </span>
      <label className="ml-auto flex min-w-0 items-center gap-2 text-xs">
        <span>Search</span>
        <input
          type="search"
          data-test="admin-onboarding-search"
          aria-label="Search onboarding by vessel, code, IMO or email"
          placeholder="Vessel, code, IMO or email"
          value={search}
          onChange={(event) => onSearch(event.target.value)}
          className="h-8 w-64 max-w-full border border-gray-300 bg-transparent px-2 text-sm dark:border-gray-600"
        />
      </label>
      <button
        type="button"
        data-test="admin-onboarding-refresh"
        aria-label="Refresh onboarding"
        title="Refresh"
        disabled={disabled}
        onClick={onRefresh}
        className="inline-flex h-8 w-8 items-center justify-center border border-gray-300 text-green hover:bg-[#E9F4F3] disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700"
      >
        <ArrowPathIcon className="h-4 w-4" />
      </button>
    </header>
  );
};

export default AdminOnboardingTopBar;
